<div class="main-content-section">
  <div class="section-content">
    <app-top-menu></app-top-menu>

    <router-outlet></router-outlet>
  </div>
</div>
